/**
 * Split settings components to their own chunk.
 * Additionally to reducing the code for the main bundle, it prevents loading
 * Stripe at app launch and helps reduce our TTI.
 */
import * as React from 'react';

export const SettingsScreen = React.lazy(() => import('./SettingsScreen'));
export const OrganizationBillingSettings = React.lazy(
    () => import('./OrganizationSettings/OrganizationBillingSettings')
);
export const OrganizationMigrateSettings = React.lazy(
    () => import('./OrganizationSettings/OrganizationMigrateSettings')
);
